export const DROPOFF_BEFORE_PICKUP = 'DROPOFF_BEFORE_PICKUP';
export const INSUFFICIENT_TIME_RANGE = 'INSUFFICIENT_TIME_RANGE';
